import React from "react";
import { NavLink } from "react-router-dom";

interface SmartLinkProps extends React.HTMLProps<HTMLDivElement> {
  url?: string;
}

const SmartLink: React.FC<SmartLinkProps> = ({
  url,
  children,
  className,
  style,
}) => {

  if (!!url) {

    if (url.startsWith("/")) {
      return (
        <NavLink to={url} className={className} style={style}>
          {children}
        </NavLink>);
    }

    if (url.startsWith("mailto:")) {
      return (
        <a href={url} className={className} style={style}>
          {children}
        </a>);
    }

    return (
      <a href={url} target="_blank" className={className} style={style}>
        {children}
      </a>);
  }

  return (<>{children}</>);
}

export default SmartLink;
